package er.prateek.crossly.share

import kotlinx.serialization.Serializable

data class SharePayload(
    val kind: Kind,
    val name: String,
    val puzzleId: String = "",
    val shareId: String = "",
    val origin: String = "",
    /** Challenger best time (challenge) or winner time (result), milliseconds. */
    val timeMs: Long = 0,
    /** Original challenger's time on a result share, milliseconds. */
    val opponentTimeMs: Long = 0,
    /** Sender's per-install id. Own-link detection uses this, never the display name. */
    val installId: String = "",
    /** Questions the challenger answered correctly (riddle challenges); 0 when not applicable. */
    val score: Int = 0,
) {
    enum class Kind { APP_SHARE, CHALLENGE, RESULT }

    val isChallenge: Boolean get() = kind == Kind.CHALLENGE
    val isResult: Boolean get() = kind == Kind.RESULT
}

@Serializable
enum class IncomingChallengeStatus {
    OFFERED,
    ACCEPTED,
    COMPLETED,
    DECLINED,
    DONT_ASK,
}

@Serializable
data class IncomingChallenge(
    val token: String,
    val challengerName: String,
    val puzzleId: String,
    val status: IncomingChallengeStatus,
    val shareId: String = "",
    val origin: String = "",
    val bestTimeMs: Long = 0,
    val bestScore: Int = 0,
)

@Serializable
data class IncomingChallengePrefs(
    val challenge: IncomingChallenge? = null,
    val referrerConsumed: Boolean = false,
)

@Serializable
data class OutboundShare(
    val token: String,
    val puzzleId: String,
    val createdAtEpochMs: Long,
    val shareId: String = "",
)
